export default "__VITE_ASSET__BOuZ9scw__"